import { ChangeDetectionStrategy, Component, ViewEncapsulation, booleanAttribute, computed, input } from '@angular/core';

export const DS_DIVIDER_VARIANT_ARRAY = ['on-surface', 'on-surface-lowest', 'on-surface-low', 'on-surface-high', 'on-surface-highest'] as const;
export type DsDividerVariant = (typeof DS_DIVIDER_VARIANT_ARRAY)[number];

// eslint-disable-next-line @nx/workspace-component-tests-present
@Component({
    selector: 'ds-divider',
    standalone: true,
    template: ``,
    host: {
        'class': 'ds-divider',
        '[class]': 'hostClass()',
        '[class.ds-divider-vertical]': 'vertical()',
        '[class.ds-divider-inverse]': 'inverse()',
        // 'role': 'separator', // sometimes nested in list group with role "listbox" where only specific roles are allowed -> "option")
        // '[attr.aria-orientation]': 'vertical ? "vertical" : "horizontal"',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./divider.component.scss'],
})
export class DsDivider {
    public readonly vertical = input(false, { transform: booleanAttribute });
    public readonly variant = input<DsDividerVariant>('on-surface-lowest');
    public readonly inverse = input(false, { transform: booleanAttribute });

    protected readonly hostClass = computed(() => `ds-divider-${this.variant()}`);
}
